import { SVGProps } from 'react';

const IcSuccess = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 48 48' fill='none'>
      <path
        d='M44.5996 24C44.5996 12.6229 35.3771 3.40039 24 3.40039C12.6229 3.40039 3.40039 12.6229 3.40039 24C3.40039 35.3771 12.6229 44.5996 24 44.5996V48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48V44.5996C35.3771 44.5996 44.5996 35.3771 44.5996 24Z'
        fill={props.fill || '#1D2129'}
      />
      <path
        d='M20.0221 34C19.4618 34 18.9296 33.7768 18.5374 33.3861L10.6093 25.4894C9.7969 24.6802 9.7969 23.3408 10.6093 22.5316C11.4217 21.7224 12.7664 21.7224 13.5788 22.5316L20.0221 28.9494L34.4212 14.6069C35.2336 13.7977 36.5783 13.7977 37.3907 14.6069C38.2031 15.4161 38.2031 16.7555 37.3907 17.5647L21.5068 33.3861C21.1146 33.7768 20.5824 34 20.0221 34Z'
        fill={props.fill || '#1D2129'}
      />
    </svg>
  );
};

export default IcSuccess;
